import type { FailedInvite } from 'bundles/enterprise-admin-learners/hooks/useInviteLearners';

import _t from 'i18n!nls/enterprise-admin-learners';

// Prevents CSV formula injection: a cell starting with =, +, -, or @ is treated as a
// formula by Excel/LibreOffice, so a malicious email or server message could otherwise
// execute arbitrary commands when the admin opens this file.
const CSV_FORMULA_TRIGGER_CHARS = ['=', '+', '-', '@'];
const sanitizeCsvFormulaTrigger = (cell: string) =>
  CSV_FORMULA_TRIGGER_CHARS.includes(cell.charAt(0)) ? `'${cell}` : cell;

const escapeCsvCell = (cell: string) => `"${sanitizeCsvFormulaTrigger(cell).replace(/"/g, '""')}"`;

/** Generates and downloads a client-side CSV of failed invites — there's no server-generated report for this mutation. */
export const downloadInviteErrorReport = (failed: FailedInvite[]) => {
  const rows = [
    [_t('Email'), _t('Error code'), _t('Message')],
    ...failed.map((invite) => [invite.email, invite.errorCode, invite.message]),
  ];
  const csv = rows.map((row) => row.map(escapeCsvCell).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'invite-errors.csv';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();

  window.setTimeout(() => {
    link.parentNode?.removeChild(link);
    URL.revokeObjectURL(url);
  }, 0);
};
